import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

export type EventName = string;

interface Event<T = Record<string, unknown>> {
    name: EventName;
    data: T;
}

@Injectable({ providedIn: 'root' })
export class EventService {
    private readonly events$ = new Subject<Event>();

    emit<T extends Record<string, unknown> = Record<string, unknown>>(name: EventName, data: T): void {
        this.events$.next({ name, data });
    }

    listen<T extends Record<string, unknown> = Record<string, unknown>>(name: EventName, callback: (data: T) => void): () => void {
        const subscription = this.events$.pipe(
            filter(event => event.name === name),
            map(event => event.data as T)
        ).subscribe(callback);

        return () => subscription.unsubscribe();
    }

    once<T extends Record<string, unknown> = Record<string, unknown>>(name: EventName, callback: (data: T) => void): void {
        this.events$.pipe(
            filter(event => event.name === name),
            map(event => event.data as T),
            take(1)
        ).subscribe(callback);
    }
}
